import { NavLink } from "react-router-dom";

export default function StudentSidebar() {
  const menuItems = [
    { path: "/student", label: "الرئيسية", icon: "🏠", end: true },
    { path: "/student/trainers", label: "المدرّبين", icon: "👨‍🏫" },
    { path: "/student/my-courses", label: "كورساتي", icon: "📚" },
    { path: "/student/profile", label: "الملف الشخصي", icon: "👤" },
  ];

  return (
    <div style={styles.container}>
      <aside style={styles.sidebar}>
        {/* رأس السايدبار */}
        <div style={styles.header}>
          <div style={styles.brand}>
            <div style={styles.logo}>👨‍🎓</div>
            <h1 style={styles.title}>منصة الطالب</h1>
          </div>
        </div>

        {/* قائمة التنقل */}
        <nav style={styles.nav}>
          <ul style={styles.menu}>
            {menuItems.map((item) => (
              <li key={item.path} style={styles.menuItem}>
                <NavLink
                  to={item.path}
                  end={item.end}
                  style={({ isActive }) => ({
                    ...styles.menuLink,
                    ...(isActive && styles.menuLinkActive),
                  })}
                >
                  <span style={styles.menuIcon}>{item.icon}</span>
                  <span style={styles.menuLabel}>{item.label}</span>
                  <span style={styles.menuArrow}>›</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        {/* تذييل السايدبار */}
        <div style={styles.footer}>
          <div style={styles.userInfo}>
            <div style={styles.userAvatar}>
              <span style={styles.avatarText}>ط</span>
            </div>
            <div style={styles.userDetails}>
              <span style={styles.userName}>الطالب</span>
              <span style={styles.userStatus}>نشط الآن</span>
            </div>
          </div>
        </div>
      </aside>
    </div>
  );
}

const styles = {
  container: {
    position: 'relative',
    height: '100vh',
  },
  sidebar: {
    width: '220px',
    height: '100%',
    background: 'linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%)',
    borderLeft: '1px solid #e0e0e0',
    padding: '0',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '-2px 0 10px rgba(0, 0, 0, 0.05)',
    direction: 'rtl',
  },
  header: {
    padding: '25px 20px',
    borderBottom: '1px solid #f0f0f0',
    background: 'white',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  logo: {
    fontSize: '1.8rem',
    background: 'linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%)',
    width: '40px',
    height: '40px',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
  },
  title: {
    margin: 0,
    fontSize: '1rem',
    fontWeight: '700',
    color: '#333',
  },
  nav: {
    flex: 1,
    padding: '20px 0',
  },
  menu: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
  },
  menuItem: {
    marginBottom: '5px',
  },
  menuLink: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    color: '#555',
    textDecoration: 'none',
    padding: '12px 20px',
    margin: '0 10px',
    borderRadius: '8px',
    transition: 'all 0.2s ease',
  },
  menuLinkActive: {
    background: 'linear-gradient(90deg, rgba(76, 175, 80, 0.1) 0%, rgba(46, 125, 50, 0.05) 100%)',
    color: '#2E7D32',
    fontWeight: '600',
    borderRight: '3px solid #4CAF50',
  },
  menuIcon: {
    fontSize: '1.2rem',
    minWidth: '24px',
    textAlign: 'center',
  },
  menuLabel: {
    flex: 1,
    fontSize: '0.9rem',
  },
  menuArrow: {
    fontSize: '1rem',
    color: '#4CAF50',
    opacity: '0.7',
  },
  footer: {
    padding: '20px',
    borderTop: '1px solid #f0f0f0',
    background: '#f8f9fa',
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  userAvatar: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #2196F3 0%, #1976D2 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1rem',
    fontWeight: 'bold',
    color: 'white',
  },
  avatarText: {
    color: 'white',
  },
  userDetails: {
    flex: 1,
  },
  userName: {
    display: 'block',
    fontSize: '0.85rem',
    color: '#333',
    fontWeight: '600',
    marginBottom: '3px',
  },
  userStatus: {
    fontSize: '0.75rem',
    color: '#4CAF50',
    fontWeight: '500',
  },
};

// إضافة تأثيرات Hover بسيطة
if (typeof window !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = `
    .menu-link-hover:hover {
      background: rgba(76, 175, 80, 0.08);
      color: #2E7D32;
    }
    
    .menu-link-active:hover {
      background: rgba(76, 175, 80, 0.15);
    }
    
    .user-avatar-hover:hover {
      transform: scale(1.05);
      transition: transform 0.2s ease;
    }
    
    @media (max-width: 768px) {
      .sidebar-responsive {
        width: 100% !important;
        height: auto !important;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 100;
        border-left: none;
        border-top: 1px solid #e0e0e0;
        flex-direction: row !important;
      }
      
      .header-responsive {
        display: none !important;
      }
      
      .nav-responsive {
        flex: 1;
        padding: 10px 0 !important;
      }
      
      .menu-responsive {
        display: flex !important;
        justify-content: space-around !important;
      }
      
      .menu-item-responsive {
        margin-bottom: 0 !important;
        flex: 1;
      }
      
      .menu-link-responsive {
        flex-direction: column !important;
        gap: 5px !important;
        padding: 8px 5px !important;
        margin: 0 5px !important;
        font-size: 0.8rem;
      }
      
      .menu-label-responsive {
        font-size: 0.75rem !important;
      }
      
      .menu-arrow-responsive {
        display: none !important;
      }
      
      .footer-responsive {
        display: none !important;
      }
    }
  `;
  document.head.appendChild(style);

  // إضافة classes للعناصر
  setTimeout(() => {
    const menuLinks = document.querySelectorAll('[style*="menuLink"]');
    menuLinks.forEach(link => {
      link.className = (link.className || '') + ' menu-link-hover';
    });

    const userAvatar = document.querySelector('[style*="userAvatar"]');
    if (userAvatar) {
      userAvatar.className = (userAvatar.className || '') + ' user-avatar-hover';
    }

    // جعل السايدبار متجاوب للجوال
    if (window.innerWidth <= 768) {
      const sidebar = document.querySelector('[style*="sidebar"]');
      const header = document.querySelector('[style*="header"]');
      const nav = document.querySelector('[style*="nav"]');
      const menu = document.querySelector('[style*="menu"]');
      const menuItems = document.querySelectorAll('[style*="menuItem"]');
      const menuLinks = document.querySelectorAll('[style*="menuLink"]');
      const menuLabels = document.querySelectorAll('[style*="menuLabel"]');
      const menuArrows = document.querySelectorAll('[style*="menuArrow"]');
      const footer = document.querySelector('[style*="footer"]');

      if (sidebar) sidebar.className = (sidebar.className || '') + ' sidebar-responsive';
      if (header) header.className = (header.className || '') + ' header-responsive';
      if (nav) nav.className = (nav.className || '') + ' nav-responsive';
      if (menu) menu.className = (menu.className || '') + ' menu-responsive';
      
      menuItems.forEach(item => {
        item.className = (item.className || '') + ' menu-item-responsive';
      });
      
      menuLinks.forEach(link => {
        link.className = (link.className || '') + ' menu-link-responsive';
      });
      
      menuLabels.forEach(label => {
        label.className = (label.className || '') + ' menu-label-responsive';
      });
      
      menuArrows.forEach(arrow => {
        arrow.className = (arrow.className || '') + ' menu-arrow-responsive';
      });
      
      if (footer) footer.className = (footer.className || '') + ' footer-responsive';
    }
  }, 100);
}